export const formatNumber = number => {
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const formatViewers = viewers => {
  return Math.abs(viewers) > 999
    ? Math.sign(viewers) * (Math.abs(viewers) / 1000).toFixed(1) + "k"
    : Math.sign(viewers) * Math.abs(viewers);
};

export const getElapsedTime = (from, to) => {
  var elapsed = (from - to) / 1000;

  if (elapsed >= 0) {
    const diff = {};
    diff.hours = "00";
    diff.minutes = "00";
    diff.seconds = "00";

    if (elapsed >= 3600) {
      diff.hours = Math.floor(elapsed / 3600);
      elapsed -= diff.hours * 3600;
      if (diff.hours < 10) {
        diff.hours = `0${diff.hours}`;
      }
    }

    if (elapsed >= 60) {
      diff.minutes = Math.floor(elapsed / 60);
      elapsed -= diff.minutes * 60;
      if (diff.minutes < 10) {
        diff.minutes = `0${diff.minutes}`;
      }
    }
    diff.seconds = Math.floor(elapsed);

    if (diff.seconds < 10) {
      diff.seconds = `0${diff.seconds}`;
    }

    let message = `${diff.hours}:${diff.minutes}:${diff.seconds}`;
    return message;
  }
  return "00:00:00";
};

export const paginate = (array, pageSize, pageNumber) => {
  --pageNumber; // because pages logically start with 1, but technically with 0
  return array.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
};

export const appendZeroForDate = hour => {
  if (hour < 10) {
    return `0${hour}`;
  }
  return hour;
};

export const isEmail = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export default {
  formatNumber,
  formatViewers,
  getElapsedTime,
  paginate,
  appendZeroForDate,
  isEmail
};
